import React from "react";
import "./components.css";

export function LoginErrors(props)  {
        return (
            <div className="error">{props.error}</div>
        );
}

export default LoginErrors;